import React, { useState } from "react";
import Logo from "../../assets/Logo.svg";
import Button from "../../components/common/Button";
import { scroller } from "react-scroll";
import { Link as NavLink } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { name: "Features", link: "features" },
  { name: "Use Cases", link: "usecase" },
  { name: "Pricing", link: "pricing" },
  { name: "How It Works", link: "howItWorks" },
  { name: "Blogs", link: "blogs" },
];

const AboutNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
   const [showMenu, setShowMenu] = useState(false);
   const location = useLocation();
   const navigate = useNavigate();
 
   const handleNav = (section) => {
     if (location.pathname === "/") {
       scroller.scrollTo(section, {
         smooth: true,
         duration: 600,
         offset: -80,
       });
     } else {
       navigate("/", {
         state: { scrollTo: section },
       });
     }
   };
 
  const handleMenuOpen = () => {
    setShowMenu(true);
    setTimeout(() => {
      setIsMenuOpen(true);
    }, 10); 
  };
  const handleMenuClose = () => {
    setIsMenuOpen(false);
    setTimeout(() => {
      setShowMenu(false);
    }, 300); 
  };

  return (
    <nav className="relative z-10 py-6">
     <div className="px-4 max-w-6xl mx-auto">
       <div className="bg-[#111219] border border-[#FFFFFF33] py-1 md:py-0 px-2   rounded-xl flex justify-between items-center">
        <NavLink to="/">
          <img src={Logo} alt="Logo" className="w-26" />
        </NavLink>
        <div className="md:hidden mt-2">
          <button
            onClick={showMenu ? handleMenuClose : handleMenuOpen}
            className="text-white focus:outline-none"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              {showMenu ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
              <ul className="hidden md:flex gap-6 items-center p-4 text-[13px]">
                  {navItems.map((item, index) =>
                    item.name === "Blogs" ? (
                      <NavLink to="/blogs" key={index}>
                        <li className="text-gray-300 cursor-pointer hover:text-blue-200 active:text-white">
                          {item.name}
                        </li>
                      </NavLink>
                    ) : (
                      <li
                        key={index}
                        onClick={() => handleNav(item.link)}
                        className="text-gray-300 cursor-pointer hover:text-blue-200 active:text-white"
                      >
                        {item.name}
                      </li>
                    )
                  )}
                </ul>

        <div className="hidden  md:block">
          <Button text={"Try For Free"} path="https://app.agoravoice.ai"/>
        </div>
      </div>
      {showMenu && (
        <div
          className="fixed inset-0 z-50 bg-[#00000080] backdrop-blur-sm flex justify-center items-start pt-[100px] md:hidden"
          onClick={handleMenuClose}
        >
          <div
            className={`relative bg-[#ffffff05] border border-[#FFFFFF33] rounded-[12px] p-4 w-[90%] max-w-[400px] space-y-4 transition-all duration-300 transform ${
              isMenuOpen
                ? "translate-y-0 opacity-100"
                : "-translate-y-full opacity-0"
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close (X) icon */}
            <button
              className="absolute top-4 right-2 text-white focus:outline-none"
              onClick={handleMenuClose}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

           <ul className="flex flex-col items-center gap-4">
                       {navItems.map((item, index) =>
                         item.name === "Blogs" ? (
                           <NavLink
                             to="/blogs"
                             key={index}
                             onClick={handleMenuClose}
                           >
                             <li className="text-white mt-2">{item.name}</li>
                           </NavLink>
                         ) : (
                           <li
                             key={index}
                             onClick={() => {
                               handleNav(item.link);
                               handleMenuClose();
                             }}
                             className="text-white mt-2 cursor-pointer"
                           >
                             {item.name}
                           </li>
                         )
                       )}
                     </ul>
       
          <div className="flex justify-center"> 
              <a
          href="https://app.agoravoice.ai"
          target="_blank"
          className={` hover:from-[#B22222] hover:to-[#B22222]  bg-gradient-to-r from-[#B22222] to-[#FF4D4D]  font-semibold  border border-gray-400  text-white px-4 py-1.5 rounded-full`} rel="noreferrer"
        >
    Try For Free
        </a>
            </div>
      
          </div>
        </div>
      )}
     </div>
    </nav>
  );
};

export default AboutNavbar;
